export default "__VITE_ASSET__UQ2EGAP5__"